import { z } from "zod";

export const EXCUSE_SCHEME = z.object({
    // первая часть формы
    iin: z.string({ message: "Впишите ИИН" }).length(12, "Введите ИИН"),
    full_name: z.string({ message: "Впишите ваше ФИО" }).min(2, { message: "Впишите ваше ФИО" }).regex(/^[а-яА-ЯёЁa-zA-Z\u04D8\u04D9\u04B0\u04B1\u0406\u0456\u04A2\u04A3\u0492\u0493\u04AE\u04AF\u049A\u049B\u04E8\u04E9\u04BA\u04BB\s-]+$/, { message: "Недопустимый символ" }),
    country: z.string({ message: "Выберите страну" }).min(2, { message: "Выберите страну" }),
    city_id: z.string({ message: "Укажите город" }),
    address: z.string({ message: "Укажите адрес прожинивая или адрес прописки" }).min(2, { message: "Укажите адрес проживания или адрес прописки" }),
    phone: z.string({ message: "Укажите номер телефона" }).regex(/\+7 \(\d{3}\) \d{3} \d{2} \d{2}/, { message: "Укажите номер телефона" }),
    email: z.string({ message: "Укажите email" }).email({ message: "Укажите email" }),
    event_address: z.string({ message: "Укажите адрес события" }).min(2, { message: "Укажите адрес события" }),
    applicant_type_isn: z.string({ message: "Выберите тип заявителя" }),
    victim_vehicle_mark_model: z.string({ message: "Укажите марку автомобиля" }).min(2, { message: "Укажите марку автомобиля" }),
    victim_vehicle_plate_number: z.string({ message: "Укажите номер автомобиля" }).min(2, { message: "Укажите номер автомобиля" }).max(8, "Не более 8 символов"),

    // вторая часть формы
    event_date: z.string({ message: "Укажите дату события" }).min(2, { message: "Укажите дату события" }),
    event_time: z.string({ message: "Укажите время события" }).time({ message: "Введите валидное время" }),

    event_location_isn: z.string({ message: "Выберите место события" }),

    event_fault_type_isn: z.string({ message: "Выберите ответственную сторону" }),
    perpetrator_iin: z.string({ message: "Укажите ИИН виновника" }).length(12, { message: "Введите ИИН виновника" }).optional(),
    perpetrator_full_name: z.string({ message: "Укажите ФИО виновника" }).min(2, { message: "Впишите ФИО виновника" }).regex(/^[а-яА-ЯёЁa-zA-Z\u04D8\u04D9\u04B0\u04B1\u0406\u0456\u04A2\u04A3\u0492\u0493\u04AE\u04AF\u049A\u049B\u04E8\u04E9\u04BA\u04BB\s-]+$/, { message: "Недопустимый символ" }).optional(),

    perpetrator_vehicle_mark_model: z.string({ message: "Укажите марку автомобился виновника" }).min(2, { message: "Укажите марку автомобился виновника" }).optional(),
    perpetrator_vehicle_plate_number: z.string({ message: "Укажите номер автомобиля виновника" }).min(2, { message: "Укажите номер автомобиля виновника" }).max(8, "Не более 8 символов").optional(),

    event_description: z.string({ message: "Укажите краткое описание" }).min(2, { message: "Укажите краткое описание" }).max(4000, { message: "Не более 4000 символов" }),
    estimated_damage_amount: z.string({ message: "Укажите сумму ущерба" }).min(2, { message: "Укажите сумму ущерба" }),

    is_registered_by_authorities: z.enum(["true", "false"], { message: "Выберите ответ" }),
    alcohol_test_passed: z.enum(["true", "false"], { message: "Выберите ответ" }),
    is_surveyor_present: z.enum(["true", "false"], { message: "Выберите ответ" }),
    has_video_recording: z.enum(["true", "false"], { message: "Выберите ответ" }),
    is_total_loss: z.enum(["true", "false"], { message: "Выберите ответ" }),

    // файлы
    victim_id_card: z.preprocess(value => value !== undefined ? value : null, z.instanceof(File, { message: "Загрузите файл" })),
    vehicle_registration_certificate: z.preprocess(value => value !== undefined ? value : null, z.instanceof(File, { message: "Загрузите файл" })),
    driver_license: z.preprocess(value => value !== undefined ? value : null, z.instanceof(File, { message: "Загрузите файл" })),
    waybill_or_driving_permit: z.preprocess(value => value !== undefined ? value : null, z.instanceof(File, { message: "Загрузите файл" })),
    power_of_attorney_representative: z.preprocess(value => value !== undefined ? value : null, z.instanceof(File, { message: "Загрузите файл" })),
    police_report_or_court_decision: z.instanceof(File, { message: "Загрузите файл" }).optional(),
    medical_examination_report: z.instanceof(File, { message: "Загрузите файл" }).optional(),
}).superRefine((data, ctx) => {
    const mustBeRequired = data.event_fault_type_isn === "6196321";

    if (mustBeRequired && !data.perpetrator_iin) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Обязательное поле",
            path: ["perpetrator_iin"],
        });
    }
}).superRefine((data, ctx) => {
    const mustBeRequired = data.event_fault_type_isn === "6196321";

    if (mustBeRequired && !data.perpetrator_full_name?.trim()) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Обязательное поле",
            path: ["perpetrator_full_name"],
        });
    }
}).superRefine((data, ctx) => {
    const mustBeRequired = data.event_fault_type_isn === "6196321";

    if (mustBeRequired && !data.perpetrator_vehicle_mark_model?.trim()) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Обязательное поле",
            path: ["perpetrator_vehicle_mark_model"],
        });
    }
}).superRefine((data, ctx) => {
    const mustBeRequired = data.event_fault_type_isn === "6196321";

    if (mustBeRequired && !data.perpetrator_vehicle_plate_number?.trim()) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Обязательное поле",
            path: ["perpetrator_vehicle_plate_number"],
        });
    }
});